import React from 'react';
import Filter from './Filter';
import { find, capitalize } from 'lodash';
import DropdownMenu from '../../common/DropdownMenu';

var tagSvg = require('!svg-inline-loader!../../../../public/img/tag.svg');
var arrowDownSvg = require('!svg-inline-loader!../../../../public/img/arrow-down.svg');
var imprintsSvg = require('!svg-inline-loader!../../../../public/img/icons/imprints.svg');
var artistsSvg = require('!svg-inline-loader!../../../../public/img/icons/artists.svg');
var productsSvg = require('!svg-inline-loader!../../../../public/img/icons/products.svg');
var tracksSvg = require('!svg-inline-loader!../../../../public/img/icons/tracks.svg');
var projectsSvg = require('!svg-inline-loader!../../../../public/img/icons/projects.svg');

const headerSettings = [
    {
        id: "entity_title",
        title: "Entity",
        count: "any"
    },
    {
        id: "reference",
        title: "Title",
        count: "any"
    },
    {
        id: "notes",
        title: "Notes",
        count: "any"
    },
    {
        id: "tag",
        title: "Tag",
        count: "any"
    },
    {
        id: "occurs_start",
        title: "Start Date",
        count: ""
    },
    {
        id: "ends_end",
        title: "End Date",
        count: ""
    },
    {
        id: "added_end",
        title: "Added At",
        count: ""
    }
];

const entitiesObjects = [
    { type: "imprints", icon: imprintsSvg },
    { type: "artists", icon: artistsSvg },    
    { type: "projects", icon: projectsSvg },    
    { type: "products", icon: productsSvg },
    { type: "tracks", icon: tracksSvg },
  ];

const catalogKeys = ['imprints', 'artists', 'projects', 'products', 'tracks'];

class FilterButton extends React.Component {
    
    
    constructor(props){
        super(props);
        this.state = {
            filterComponentRef: React.createRef(),
            expanded: false,
            display: []
        }

        this.renderSelected = this.renderSelected.bind(this)
    }
    
    toggleFilter = (event, force) => {
        this.setState({
            expanded: force !== undefined ? force : !this.state.expanded
        })
    }
    
    getFilteredValue = (filtered, key) => {
        if (!Array.isArray(filtered)) return null;

        const item = filtered.find(item => item.id === key);

        if (!item || item.value === null || item.value === undefined || item.value === '') {
            return null;
        }

        return item.value;
    };

    dropdownHeader = (filtered, entity, dropdown = true) => {
        const item = headerSettings.find(item => item.id === entity);

        if (!item) return null;

        const title = item.title;
        const count = item.count;
        const value = this.getFilteredValue(filtered, entity);

        return (
            <span className="playlist-filter-text-item">
                <span
                    className="playlist-filter-result-icon"
                    dangerouslySetInnerHTML={{ __html: tagSvg }}
                />

                {title}
                {count !== '' && ` (${value || count})`}

                <a className="close-link" onClick={() => this.removeOption(entity)}>
                    &times;
                </a>

                {dropdown && (
                    <span
                        className="caret"
                        dangerouslySetInnerHTML={{ __html: arrowDownSvg }}
                    />
                )}
            </span>
        );
    };

    mergeIcons(data, entitiesObjects) {
        return data.map(item => {
            const matchingEntity = entitiesObjects.find(entity => entity.type === item.type);
            if (matchingEntity) {
                return { ...item, icon: matchingEntity.icon };
            }
            return item;
        });
    }

    showDropdownIcon(array) {
        return array.length ? true : false
    }

    getTodayDate = () => {
        return new Date().toISOString().split('T')[0];
    };

    renderSelected = (filtered, display) => {
        const entityType = this.getFilteredValue(filtered, 'entity_type');
        const entityTitle = this.getFilteredValue(filtered, 'entity_title');

        const reference = this.getFilteredValue(filtered, 'reference');
        const notes = this.getFilteredValue(filtered, 'notes');
        const tag = this.getFilteredValue(filtered, 'tag');

        const occursStart = this.getFilteredValue(filtered, 'occurs_start');
        const occursEnd = this.getFilteredValue(filtered, 'occurs_end');

        const endsStart = this.getFilteredValue(filtered, 'ends_start');
        const endsEnd = this.getFilteredValue(filtered, 'ends_end');

        const addedStart = this.getFilteredValue(filtered, 'added_start');
        const addedEnd = this.getFilteredValue(filtered, 'added_end');

        const entityIcon = entityType
            ? (entitiesObjects.find(item => item.type === entityType) || {}).icon
            : '';

        return (
            <div className="playlist-filter-result-holder">
                <div className="playlist-filter-text">

                    {entityTitle && (
                        <DropdownMenu
                            header={this.dropdownHeader(filtered, 'entity_title', true)}
                            className="playlist-dropdown"
                        >
                            <div className={`playlist-filter-result-item ${entityType || ''}`}>
                                {entityIcon && (
                                    <div
                                        className={`search-entity-logo ${entityType}`}
                                        dangerouslySetInnerHTML={{ __html: entityIcon }}
                                    />
                                )}

                                <div className="playlist-filter-result-item__tag">
                                    {entityTitle}
                                </div>
                            </div>
                        </DropdownMenu>
                    )}

                    {reference && (
                        <DropdownMenu
                            header={this.dropdownHeader(filtered, 'reference', true)}
                            className="playlist-dropdown"
                        >
                            <div className="playlist-filter-result-item">{reference}</div>
                        </DropdownMenu>
                    )}

                    {notes && (
                        <DropdownMenu
                            header={this.dropdownHeader(filtered, 'notes', true)}
                            className="playlist-dropdown"
                        >
                            <div className="playlist-filter-result-item">{notes}</div>
                        </DropdownMenu>
                    )}

                    {tag && (
                        <DropdownMenu
                            header={this.dropdownHeader(filtered, 'tag', true)}
                            className="playlist-dropdown"
                        >
                            <div className="playlist-filter-result-item">{tag}</div>
                        </DropdownMenu>
                    )}

                    {(occursStart || occursEnd) && (
                        <DropdownMenu
                            header={this.dropdownHeader(filtered, 'occurs_start', true)}
                            className="playlist-dropdown"
                        >
                            <div className="playlist-filter-result-item">
                                {occursStart || ''}
                                {' - '}
                                {occursEnd || this.getTodayDate()}
                            </div>
                        </DropdownMenu>
                    )}

                    {(endsStart || endsEnd) && (
                        <DropdownMenu
                            header={this.dropdownHeader(filtered, 'ends_end', true)}
                            className="playlist-dropdown"
                        >
                            <div className="playlist-filter-result-item">
                                {endsStart || ''}
                                {' - '}
                                {endsEnd || this.getTodayDate()}
                            </div>
                        </DropdownMenu>
                    )}

                    {(addedStart || addedEnd) && (
                        <DropdownMenu
                            header={this.dropdownHeader(filtered, 'added_end', true)}
                            className="playlist-dropdown"
                        >
                            <div className="playlist-filter-result-item">
                                {addedStart || ''}
                                {' - '}
                                {addedEnd || this.getTodayDate()}
                            </div>
                        </DropdownMenu>
                    )}
                </div>
            </div>
        );
    };
    
  
    applyFilter = (filter, display) => {
        this.setState({display});
        this.toggleFilter(null, false);
        this.props.onApply(filter);
    }
    
    removeOption = (option) => {
      const { filterComponentRef } = this.state;
      filterComponentRef.current.removeOption(option);
    }
    
    render (){
        const { expanded, display, filterComponentRef } = this.state;
        const { filtered, onApply, datesBlock } = this.props;        
        return <div className='filter-with-date-holder'>
            <div className="playlist-filter-holder">
                <button className={`filter-toggle-btn btn default-btn`} onClick={this.toggleFilter}><span className="fa fa-plus"></span> Add Filter</button>
                {this.renderSelected(filtered, display)}
                <Filter filtered={filtered} expanded={expanded} onApply={this.applyFilter} ref={filterComponentRef} />
            </div>
        </div>
    }
}

export default FilterButton;